import React from 'react';
import AppContextPropsType from '../types/AppContextPropsType';
import defaultConfig from '../types/Config';

export default React.createContext<AppContextPropsType>(defaultConfig);
